module.exports = __webpack_public_path__ + "img/11.7e41f181.jpg";